import useSWRMutation from "swr/mutation";
import { environment } from "../../config/environment";
import { EmailResponseModel } from "../../models/EmailModels";
import { DraftEmailTemplateRequest } from "../../models/EmailTemplateModels";
import { useSWRFetcher } from "../useSWRFetcher";
import { useOutlook } from "../useOutlook";
import { isMailboxRequirementSupported } from "../../taskpane";
import { useContext } from "react";
import { ToastContext } from "../../context/ToastContext";

export const useDraftEmailTemplate = () => {
  const fetcher = useSWRFetcher();
  const { showToast } = useContext(ToastContext);
  const { isInReadMode } = useOutlook();

  const dataType: DraftEmailTemplateRequest["dataType"] =
    isInReadMode && !isMailboxRequirementSupported("1.15") ? "Url" : "Base64";

  const { trigger, isMutating, error } = useSWRMutation(
    `${environment.apiUrl}/api/organisation/email-templates`,
    (url: string, { arg }: { arg: { templateId: string; templateParameters: Record<string, string> } }) =>
      fetcher<EmailResponseModel>(`${url}/${arg.templateId}`, {
        method: "POST",
        body: JSON.stringify({
          dataType,
          templateParameters: arg.templateParameters,
        } satisfies DraftEmailTemplateRequest),
      }),
    {
      onError: () => {
        showToast("Failed to draft the email from template, please try again later", "error");
      },
    }
  );

  return {
    draftEmailTemplate: trigger,
    isDraftEmailTemplateLoading: isMutating,
    isError: !!error,
  };
};
